// src/api/contactApi.js
import api from "./api"; // Assuming you have the configured axios instance

export const submitContactForm = (data) => api.post("/contact", data);
